<div class="timeline-container">
  @if (hasData()) {
    <div class="timeline-toolbar">
      <div class="timeline-toolbar-main">
        <div class="timeline-legend">
          <div class="legend-item">
            <span class="legend-dot agent"></span>
            <span>Agent</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot customer"></span>
            <span>Customer</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot suggestion"></span>
            <span>Suggestion</span>
          </div>
        </div>

        <div class="timeline-stats">
          <div class="stat-item">
            <span class="stat-value">{{ transcriptCount() }}</span>
            <span class="stat-label">transcript entries</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ suggestionCount() }}</span>
            <span class="stat-label">suggestions</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ formattedDuration() }}</span>
            <span class="stat-label">duration</span>
          </div>
        </div>
      </div>

      <div class="zoom-controls">
        <button
          type="button"
          class="zoom-button"
          (click)="zoomOut()"
          [disabled]="pixelsPerSecond() <= 12"
        >
          <i class="pi pi-minus"></i>
        </button>
        <label class="zoom-slider">
          <span>Zoom {{ zoomPercent() }}%</span>
          <input
            type="range"
            min="12"
            max="72"
            step="4"
            [value]="pixelsPerSecond()"
            (input)="setZoom($any($event.target).valueAsNumber)"
          />
        </label>
        <button
          type="button"
          class="zoom-button"
          (click)="zoomIn()"
          [disabled]="pixelsPerSecond() >= 72"
        >
          <i class="pi pi-plus"></i>
        </button>
        <button type="button" class="zoom-reset" (click)="resetZoom()">Reset</button>
      </div>
    </div>

    <div class="timeline-scroll">
      <div class="timeline-canvas" [style.height.px]="timelineHeight()">
        <div class="timeline-center-line"></div>

        @for (marker of timeMarkers(); track marker.time) {
          <div class="time-marker" [style.top.px]="marker.top">
            <span class="time-marker-label">{{ marker.label }}</span>
            <div class="time-marker-tick"></div>
          </div>
        }

        @for (pin of eventPins(); track pin.id) {
          <div
            class="timeline-pin"
            [class.agent]="pin.type === 'agent'"
            [class.customer]="pin.type === 'customer'"
            [class.suggestion]="pin.type === 'suggestion'"
            [style.top.px]="pin.top"
          ></div>
        }

        @for (item of transcriptLayouts(); track item.trackId; let index = $index) {
          <div
            class="timeline-event left"
            [style.top.px]="item.eventY"
            [style.height.px]="item.wrapperHeight"
          >
            <div class="event-stem" [style.height.px]="item.connectorHeight"></div>
            <div class="event-arm" [style.top.px]="item.connectorHeight"></div>
            <div
              #transcriptCard
              class="event-card transcript-card"
              [class.agent]="normalizedTranscriptions()[index].speaker === 'Agent'"
              [class.customer]="normalizedTranscriptions()[index].speaker === 'Customer'"
              [style.top.px]="item.cardOffset"
            >
              <div class="event-header">
                <span
                  class="speaker-badge"
                  [class.agent]="normalizedTranscriptions()[index].speaker === 'Agent'"
                  [class.customer]="normalizedTranscriptions()[index].speaker === 'Customer'"
                >
                  {{ normalizedTranscriptions()[index].speaker }}
                </span>
                <span class="event-time">
                  {{ formatTimeFromSeconds(normalizedTranscriptions()[index].relativeTime) }}
                </span>
              </div>
              <div class="event-text">{{ normalizedTranscriptions()[index].text }}</div>
            </div>
          </div>
        }

        @for (item of suggestionLayouts(); track item.trackId; let index = $index) {
          <div
            class="timeline-event right"
            [style.top.px]="item.eventY"
            [style.height.px]="item.wrapperHeight"
          >
            <div class="event-stem" [style.height.px]="item.connectorHeight"></div>
            <div class="event-arm" [style.top.px]="item.connectorHeight"></div>
            <div
              #suggestionCard
              class="event-card suggestion-card"
              [style.top.px]="item.cardOffset"
            >
              <div class="event-header">
                <span class="trigger-badge">{{ normalizedSuggestions()[index].triggerType }}</span>
                <span class="event-time">
                  {{ formatTimeFromSeconds(normalizedSuggestions()[index].relativeTime) }}
                </span>
              </div>
              <div class="event-text suggestion-text">
                {{ normalizedSuggestions()[index].suggestion }}
              </div>
              @if (normalizedSuggestions()[index].explanation) {
                <div class="suggestion-explanation">
                  {{ normalizedSuggestions()[index].explanation }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="empty-state">
      <i class="pi pi-clock"></i>
      <span>No timeline data available for this session</span>
    </div>
  }
</div>
